import { useEffect, useRef } from "react";

import BrushWord from "../components/BrushWord";
import { BookIcon, StarIcon } from "../components/Icons";
import { COURSES } from "../data/content";
import { revealUp, tilt } from "../lib/motion";
import "./Courses.css";

const TONES = ["cyan", "pink", "amber"];

export default function Courses() {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    const cards = [...root.querySelectorAll(".ilab-course")];
    const cleanups = [
      revealUp([root.querySelector(".ilab-courses__head")], { y: 30, stagger: 0 }),
      revealUp(cards, { y: 46, stagger: 0.13, trigger: root.querySelector(".ilab-courses__grid") }),
      ...cards.map((card) => tilt(card, { max: 3.5, lift: -8 })),
    ];

    return () => cleanups.forEach((fn) => fn());
  }, []);

  return (
    <section id="courses" className="section ilab-courses" ref={rootRef}>
      <div className="container">
        <header className="ilab-courses__head">
          <p className="eyebrow">Three curricula</p>
          <h2 className="section-title ilab-courses__title">
            Find the Right
            <br />
            <BrushWord variant="section">Course</BrushWord> for you
          </h2>
          <p className="section-lede">
            You don&apos;t have to struggle alone, you&apos;ve got our assistance and help.
          </p>
        </header>

        <div className="ilab-courses__grid">
          {COURSES.map((course, i) => (
            <article className="ilab-course" key={course.id}>
              <div className="ilab-course__thumb">
                <picture>
                  <source
                    type="image/webp"
                    srcSet={`/assets/images/${course.image}-420.webp 420w, /assets/images/${course.image}-640.webp 640w, /assets/images/${course.image}-760.webp 760w`}
                    sizes="(max-width: 767px) 92vw, (max-width: 1199px) 46vw, 400px"
                  />
                  <img
                    src={`/assets/images/${course.image}-640.jpg`}
                    alt={course.alt}
                    width="640"
                    height="427"
                    loading="lazy"
                    decoding="async"
                  />
                </picture>
                <span className={`ilab-course__ages ilab-course__ages--${TONES[i % TONES.length]}`}>
                  {course.ages}
                </span>
              </div>

              <div className="ilab-course__content">
                <div className="ilab-course__meta">
                  <span>
                    <BookIcon width="16" height="16" />
                    {course.lessons} Lessons
                  </span>
                  <span>
                    <StarIcon width="14" height="14" />
                    {course.rating}
                    <i>({course.reviews})</i>
                  </span>
                </div>

                <h3 className="ilab-course__title">{course.title}</h3>
                <p className="ilab-course__body">{course.body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
